import styled from 'styled-components'
import { getSpacingSelector } from '@signal/theme/selectors'

export const ContentWrapper = styled.div`
  overflow-y: auto;
  padding: ${getSpacingSelector(1.5)}px ${getSpacingSelector(3.5)}px;
`
